import { render, staticRenderFns } from "./BranchFilter.vue?vue&type=template&id=05b46203&"
import script from "./BranchFilter.vue?vue&type=script&lang=js&"
export * from "./BranchFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports